import { render, staticRenderFns } from "./EvaluationPlatform.vue?vue&type=template&id=e45619e0&scoped=true&"
import script from "./EvaluationPlatform.vue?vue&type=script&lang=js&"
export * from "./EvaluationPlatform.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationPlatform.vue?vue&type=style&index=0&id=e45619e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45619e0",
  null
  
)

export default component.exports